<template>

	<toolbar>
		<h2 class="toolbar-heading"><i class="fa" :class="headingIcon"></i> {{heading}}</h2>
	</toolbar>

</template>
<script type="text/javascript">
import Toolbar from "../../layout_fragments/Toolbar"
import NavTabs from "../../layout_fragments/NavTabs"

export default {
	name: "LibraryToolbar",
	components: {
		Toolbar,
		NavTabs
	},
	props: ["heading","headingIcon"],

}
</script>